export default __webpack_public_path__ + "static/media/home-inactive.3dec3ebe.svg";